import { Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useState } from 'react';

type ChatMessageStickerProps = {
  mediaUrl: string;
  isQuoted?: boolean;
};

const ChatMessageSticker: React.FC<ChatMessageStickerProps> = ({
  mediaUrl,
  isQuoted,
}) => {
  const [isLoadedImage, setIsLoadedImage] = useState(false);
  const widthSticker = isQuoted ? 40 : 95;
  const heightSticker = isQuoted ? 40 : 95;
  return (
    <Paper style={{ padding: 5 }} elevation={0}>
      {!isLoadedImage && (
        <Skeleton
          variant="rect"
          width={widthSticker}
          height={heightSticker}
          style={{ borderRadius: 5, backgroundColor: '#d7d7da' }}
        />
      )}
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img
        src={mediaUrl}
        onLoad={() => setIsLoadedImage(true)}
        style={{
          maxWidth: widthSticker,
          maxHeight: heightSticker,
          display: isLoadedImage ? 'block' : 'none',
        }}
      />
    </Paper>
  );
};

export default ChatMessageSticker;
